"use client";

import { Crown } from "lucide-react";
import { useTranslations } from "next-intl";

import { cn } from "@/shared/lib/utils";

import { Badge } from "./badge";

type ProInlineBadgeProps = {
  className?: string;
  size?: "sm" | "default";
};

export function ProInlineBadge({
  className,
  size = "default",
}: ProInlineBadgeProps) {
  const t = useTranslations("Profile");
  return (
    <Badge
      variant="secondary"
      className={cn(
        "shrink-0 gap-0.5 border border-border/80 font-semibold",
        size === "sm"
          ? "h-5 px-1.5 py-0 text-[9px]"
          : "px-2 py-0.5 text-[10px]",
        className,
      )}
    >
      <Crown
        className={cn(
          "shrink-0 text-amber-500",
          size === "sm" ? "size-2.5" : "size-3",
        )}
      />
      {t("proBadge")}
    </Badge>
  );
}
